import Loading from "../../components/shared/loading/Loading";
import useFetch from "../../hooks/useFetch";
import useSession from "../../hooks/useSession";
import { apiPath } from "../../utility/Constant";
import PackageCard from "./PackageCard";

const PackageListPage = () => {
    const { packageApi } = apiPath;
    const [user, loading] = useSession();
    const [packageList, packageListLoading] = useFetch(packageApi, true);
    if (packageListLoading || loading) {
        return <Loading />;
    }

    const packages = packageList.filter(item => item.slug !== "banner")
    return (
        <div className="container mx-auto lg:pt-24 py-10 px-5 lg:px-16">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                <PackageCard />
                {packages.map((packageData, index) => (
                    <PackageCard key={index} packageData={packageData} user={user.role} />
                ))}
            </div>
        </div>
    );
};

export default PackageListPage;